import { t } from '@lingui/macro';
import { colorSystem, Highlight, Tag, Thumbnail } from '@luminovo/design-system';
import * as icons from '@mui/icons-material';
import { Box, ListItem, ListItemButton, ListItemText } from '@mui/material';

interface PartListItemProps {
    selected: boolean;
    onClick: () => void;
    image?: string;
    primaryText: string;
    secondaryText: string;
    isSuggested?: boolean;
    query: string;
}

export function PartListItem({
    selected,
    onClick,
    image,
    primaryText,
    secondaryText,
    isSuggested,
    query,
}: PartListItemProps): JSX.Element {
    return (
        <ListItem
            disablePadding
            onClick={onClick}
            sx={{
                position: selected ? 'sticky' : 'relative',
                top: selected ? 0 : 'auto',
                backgroundColor: 'white',
                zIndex: selected ? 1 : 'auto',
                border: selected ? `1px solid ${colorSystem.primary[5]}` : 'none',
                borderRadius: selected ? '4px' : '0px',
            }}
        >
            <ListItemButton selected={selected}>
                <Thumbnail
                    sx={{
                        border: `1px solid ${colorSystem.neutral[2]}`,
                        borderRadius: '4px',
                    }}
                    width={`64px`}
                    height={`64px`}
                    src={image ?? 'none.png'}
                />

                <Box sx={{ display: 'flex', flexDirection: 'column', width: '16px' }}></Box>
                <ListItemText
                    primary={<Highlight matcher={[query]} label={primaryText} />}
                    secondary={<Highlight matcher={[query]} label={secondaryText} />}
                    slotProps={{
                        secondary: {
                            fontWeight: 'normal',
                            fontSize: '12px',
                        },
                    }}
                />
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginLeft: '16px' }}>
                    {isSuggested && <Tag label={t`Suggested`} attention="low" color={'yellow'} />}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {selected ? (
                            <icons.CheckCircle style={{ color: colorSystem.primary[5] }} />
                        ) : (
                            <icons.CircleOutlined style={{ color: colorSystem.neutral[4] }} />
                        )}
                    </Box>
                </Box>
            </ListItemButton>
        </ListItem>
    );
}
